module.exports = __webpack_public_path__ + "static/media/CD.e25a3dae.svg";